class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
      console.log("🔄 connectedCallback() triggered: Cart component loaded");
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart_discounts'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cs-discount-form'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#promotion-cart-data-container'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
 
        const parsedState = JSON.parse(state);
               //temp
        // Log the entire parsedState object to the console
        console.log("DEBUG: Parsed Cart State:", parsedState);
        //end temp
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        
        if(document.querySelector('#original_total_price')){
          /*new code*/
          // Get the minimum order amount
            let minOrder = Number(document.querySelector('#original_total_price').getAttribute('data-minimum-order'));
            
            // Start with the discounted cart total
            /*let adjustedTotal = parsedState.total_price;*/
            let adjustedTotal = Math.max(0, parsedState.original_total_price - parsedState.total_discount);

            
            // Subtract e-gift card values
            let giftCardTotal = 0;
            let egiftCardVariants = ["49611922276642","49611922309410","49611922342178","49611922374946","49611922407714","49611922440482","49611922473250"]; // Replace with actual e-gift card variant IDs
            
            parsedState.items.forEach(item => {
                if (egiftCardVariants.includes(item.variant_id.toString())) {
                    giftCardTotal += item.original_line_price;
                }
            });
            
            // Subtract gift card purchases from the cart total
            adjustedTotal -= giftCardTotal;
            
            // Update checkout button & error message
            //if (adjustedTotal < minOrder) {
           if (adjustedTotal < minOrder && !(adjustedTotal === 0 && giftCardTotal > 0)) {
                document.querySelector('.cart__ctas button#checkout').style.display = "none";
                document.querySelector('#original_total_price').style.display = "block";
                document.querySelector('#original_total_price span.current-total').innerHTML = Shopify.formatMoney(adjustedTotal);
            } else {
                document.querySelector('.cart__ctas button#checkout').style.display = "block";
                document.querySelector('#original_total_price').style.display = "none";
            }
            //if there was a coupon error but the cart change made the coupon valid need to clear error
            if (parsedState.total_discount > 0) {
              const errorMessage = document.querySelector('p.cs-error');
              if (errorMessage) {
                errorMessage.style.display = 'none';
              }
            }


          /*end new code*/
          /*changed logic to allow changes to main-cart-footer to test against total after discounts and excluding gift cards Mar 2025
          if(parsedState.original_total_price<Number(document.querySelector('#original_total_price').getAttribute('data-minimum-order'))){
            document.querySelector('.cart__ctas button#checkout').style.display = "none";
            document.querySelector('#original_total_price').style.display = "block";
            document.querySelector('#original_total_price span.current-total').innerHTML = Shopify.formatMoney(parsedState.original_total_price);
          }else{
            document.querySelector('.cart__ctas button#checkout').style.display = "block";
            document.querySelector('#original_total_price').style.display = "none";
          }*/
        }

        if (typeof Shopify.updateAddedToCartSection === 'function') {
          Shopify.updateAddedToCartSection();
        }
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
          updatePromotionMessage();
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};

function updatePromotionMessage() {
      console.log("🚨 updatePromotionMessageRun!");
    const promotionCartData = document.querySelector('#promotion-cart-data');

    if (!promotionCartData) {
        console.warn("🚨 #promotion-cart-data not found!");
        return;
    }
    // Get updated values from the dynamically rendered div
    const difference = Number(promotionCartData.getAttribute('data-difference'));
     console.log("🔍 difference raw:", difference);
    const progressPercent = Number(promotionCartData.getAttribute('data-progress-percent'));
    console.log("🔍 progressPercent:", progressPercent);

    // Select elements
    const notEarnedMessage = document.querySelector('.free-scallops-message-not-earned');
    const earnedMessage = document.querySelector('.free-scallops-message-earned');
    const differenceSpan = document.getElementById('difference-to-earn');
    const progressFill = document.querySelector('.progress-fill');
    const progressRemaining = document.querySelector('.progress-remaining');

    // Update the difference text
    if (differenceSpan) {
        differenceSpan.innerHTML = `<strong>${Shopify.formatMoney(difference)}</strong>`;
    }

    // Handle message visibility based on progress
    if (difference > 0) {
        notEarnedMessage.style.display = "block"; // Show "not earned" message
        earnedMessage.style.display = "none"; // Hide "earned" message
    } else {
        notEarnedMessage.style.display = "none"; // Hide "not earned" message
        earnedMessage.style.display = "block"; // Show "earned" message
    }

    // Update progress bar
    if (progressFill) {
        progressFill.style.width = `${progressPercent}%`;
    }
    if (progressRemaining) {
        progressRemaining.style.width = `${100 - progressPercent}%`;
    }

    console.log("✅ Free Scallops Message & Progress Bar Updated!");
}


         /** 🔹Function to restore saved shipping date or select the first available date🔹 **/
      window.restoreSavedDateOrSelectFirst = async function(cartAttributes = null) {
          console.log("Running restoreSavedDateOrSelectFirst");
      

              // ✅ Now we have cartAttributes, process the saved date
              let savedDate = document.getElementById("selected-date-storage")?.innerHTML || null;
      
              if (savedDate) {
                  console.log("Restoring previous Shipping Delivery Date:", savedDate);
      
                  let formattedDate = savedDate; // Assuming MM/DD/YYYY format is correct
                  console.log("Before using datepicker");
      
                  /*if (csJq("#csShippingpicker").data("datepicker")) {
                      csJq("#csShippingpicker").datepicker().data("datepicker").selectDate(new Date(formattedDate));
                      document.querySelector('#csShippingpicker').value = formattedDate;
                      console.log("✅ Selected date in datepicker:", formattedDate);
                  }*/
                  let datepickerElement = csJq("#csShippingpicker");
                  if (datepickerElement.data("datepicker")) {
                      datepickerElement.datepicker().data("datepicker").selectDate(new Date(formattedDate));
                      document.querySelector("#csShippingpicker").value = formattedDate; // ✅ Manually set input field
              
                      console.log("✅ Selected date in datepicker:", formattedDate);
              
                      // 🔥 NEW: Trigger a "click" event to refresh the UI (especially for mobile)
                      setTimeout(() => {
                          datepickerElement.trigger("click");  
                      }, 200); // Slight delay to ensure selection registers
                  }
              } else {
                  console.log("No saved date found. Selecting first available date...");
                  selectFirstAvailableDate();
              }

      };

        
        // ✅ Function to select the first available date if no saved date exists
        function selectFirstAvailableDate() {
            var index = $('.cs-tab_last.active').index();
            var firstDateElement = $('.datepicker--cells-days:eq('+index+')').find('.datepicker--cell-day').not('.-disabled-').first();
            firstDateElement.trigger('click');
            console.log("Selected first available date in the datepicker.");
        }


      document.addEventListener("cart:updated", function () {
        console.log("🐀󄠠Cart updated from cart:update event listener...");
        //restoreShippingDate();
      });




